import axios from '~/utils/axios';

/**
 * Redirects the user to the Cognito OAuth flow for a specific social identity provider.
 * This bypasses the Cognito hosted UI and goes directly to the provider's login page.
 *
 * @param provider - The Cognito identity provider name ('Google', 'Facebook', 'SignInWithApple')
 */
export const redirectToCognitoSocial = async (
  provider: 'Google' | 'Facebook' | 'SignInWithApple',
): Promise<void> => {
  try {
    const response = await axios.get('/auth/cognito/login-url', {
      params: {
        identity_provider: provider,
      },
    });
    const loginUrl: string | undefined = response?.data?.loginUrl;

    if (!loginUrl) {
      console.error('Cognito social login URL not provided by API response');
      return;
    }

    window.location.href = loginUrl;
  } catch (error) {
    console.error('Unable to resolve Cognito social login URL', error);
    throw error;
  }
};

export const redirectToCognitoLogout = async (): Promise<void> => {
  try {
    const response = await axios.get('/auth/cognito/logout-url');
    const url: string | undefined = response?.data?.url;

    if (!url) {
      console.error('Cognito logout URL not provided by API response');
      return;
    }

    const TMB = process.env.TRUST_ME_BRO;
    window.location.href = TMB ? '/' : url;
  } catch (error) {
    console.error('Unable to resolve Cognito login URL', error);
  }
};
